import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Message, Placeholder, Table, Grid } from 'rsuite'
import { getProjectbudgetdisbursement } from '../../redux/actions/dashboard'
import { numberThousandSeparator } from '../../utils/formatterUtil'
import DashboradToggle from './DashboradToggle'

export default function ProjectBudgetDisbursement({
  isSetting,
  isShow,
  onSettingChange,
  dashboradName,
}) {
  const { Column, HeaderCell, Cell } = Table
  const { Paragraph } = Placeholder
  const [isLoading, setIsLoading] = useState(false)
  const [isReLoading, setIsReLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [errorMsg, setErrorMsg] = useState(false)
  const [sortColumn, setSortColumn] = React.useState()
  const [sortType, setSortType] = React.useState()

  const [schema, setSchema] = useState()

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    setIsError(false)
    try {
      let response

      if (isSetting) {
        response = mock
      } else {
        response = await getProjectbudgetdisbursement()
      }

      setSchema(response)
    } catch (e) {
      setIsError(true)
      setErrorMsg(e.message)
    }
    setIsLoading(false)
  }

  const getData = (data) => {
    if (sortColumn && sortType) {
      return data.sort((a, b) => {
        let x = a[sortColumn]
        let y = b[sortColumn]
        if (typeof x === 'string') {
          x = x.charCodeAt()
        }
        if (typeof y === 'string') {
          y = y.charCodeAt()
        }
        if (sortType === 'asc') {
          return x - y
        } else {
          return y - x
        }
      })
    }
    return data
  }

  const handleSortColumn = (sortColumn, sortType) => {
    // console.log(sortColumn, sortType)
    setIsReLoading(true)
    setTimeout(() => {
      setIsReLoading(false)
      setSortColumn(sortColumn)
      setSortType(sortType)
    }, 500)
  }

  const BudgetCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props}>{numberThousandSeparator(rowData[dataKey])}</Cell>
  )

  if (!schema || isLoading) {
    return (
      <Panel shaded bordered defaultExpanded>
        <Paragraph rows={10}></Paragraph>
      </Panel>
    )
  }

  return (
    <>
      {isSetting && (
        <DashboradToggle
          onChange={onSettingChange}
          dashboradName={dashboradName}
          checked={isShow}
        />
      )}

      <Panel
        header={schema.header}
        bordered
        collapsible
        defaultExpanded
        shaded
        style={{ marginTop: 10 }}
      >
        <Row style={{ marginBottom: 15 }}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Table
              rowKey="id"
              height={400}
              autoHeight={schema.data?.length <= 5}
              wordWrap={true}
              data={getData(schema.data)}
              loading={isLoading || isReLoading}
              sortColumn={sortColumn}
              sortType={sortType}
              onSortColumn={handleSortColumn}
            >
              <Column width={140} align="center" sortable>
                <HeaderCell>ปีงบประมาณแผน</HeaderCell>
                <Cell dataKey="budgetPlanYear" />
              </Column>
              <Column width={150} align="center" sortable>
                <HeaderCell>รหัสแผน</HeaderCell>
                <Cell dataKey="budgetPlanCode" />
              </Column>
              <Column minWidth={150} width={150} flexGrow={1} align="right" sortable>
                <HeaderCell>ค้างจ่าย</HeaderCell>
                <BudgetCell dataKey="arrears" />
              </Column>
              <Column minWidth={150} width={150} flexGrow={1} align="right" sortable>
                <HeaderCell align="center">เบิกจ่ายโครงการใหม่</HeaderCell>
                <BudgetCell dataKey="disburseNew" />
              </Column>
              <Column minWidth={150} width={150} flexGrow={1} align="right" sortable>
                <HeaderCell align="center">เบิกจ่ายโครงการต่อเนื่อง</HeaderCell>
                <BudgetCell dataKey="disburseOngoing" />
              </Column>
              <Column minWidth={150} width={150} flexGrow={1} align="right" sortable>
                <HeaderCell align="center">เบิก PO ใหม่</HeaderCell>
                <BudgetCell dataKey="disbursePONew" />
              </Column>
              <Column minWidth={150} width={150} flexGrow={1} align="right" sortable>
                <HeaderCell align="center">เบิก PO ต่อเนื่อง</HeaderCell>
                <BudgetCell dataKey="disbursePOOngoing" />
              </Column>
              <Column minWidth={150} width={150} flexGrow={1} align="right" sortable>
                <HeaderCell align="center">บริหารสำนัก</HeaderCell>
                <BudgetCell dataKey="bureau" />
              </Column>
            </Table>
          </Col>
        </Row>
      </Panel>
    </>
  )
}

const mock = {
  header: 'เบิกจ่ายงบประมาณ',
  data: [
    {
      id: '1',
      budgetPlanYear: '2564',
      budgetPlanCode: '0101110',
      arrears: 6000000,
      disburseNew: 1000000,
      disburseOngoing: 4000000,
      disbursePONew: 3000000,
      disbursePOOngoing: 2000000,
      bureau: 1000000,
    },
    {
      id: '2',
      budgetPlanYear: '2564',
      budgetPlanCode: '0101111',
      arrears: 8000000,
      disburseNew: 2000000,
      disburseOngoing: 5000000,
      disbursePONew: 4000000,
      disbursePOOngoing: 2000000,
      bureau: 2000000,
    },
    {
      id: '3',
      budgetPlanYear: '2564',
      budgetPlanCode: '0101112',
      arrears: 10000000,
      disburseNew: 3000000,
      disburseOngoing: 60000000,
      disbursePONew: 5000000,
      disbursePOOngoing: 2000000,
      bureau: 3000000,
    },
    {
      id: '4',
      budgetPlanYear: '2564',
      budgetPlanCode: '0101113',
      arrears: 12000000,
      disburseNew: 4000000,
      disburseOngoing: 7000000,
      disbursePONew: 6000000,
      disbursePOOngoing: 2000000,
      bureau: 4000000,
    },
    {
      id: '5',
      budgetPlanYear: '2564',
      budgetPlanCode: '0101114',
      arrears: 14000000,
      disburseNew: 5000000,
      disburseOngoing: 8000000,
      disbursePONew: 7000000,
      disbursePOOngoing: 2000000,
      bureau: 5000000,
    },
    {
      id: '6',
      budgetPlanYear: '2564',
      budgetPlanCode: '0101115',
      arrears: 16000000,
      disburseNew: 6000000,
      disburseOngoing: 9000000,
      disbursePONew: 8000000,
      disbursePOOngoing: 2000000,
      bureau: 6000000,
    },
    {
      id: '7',
      budgetPlanYear: '2564',
      budgetPlanCode: '0101116',
      arrears: 18000000,
      disburseNew: 7000000,
      disburseOngoing: 10000000,
      disbursePONew: 9000000,
      disbursePOOngoing: 2000000,
      bureau: 7000000,
    },
    {
      id: '8',
      budgetPlanYear: '2564',
      budgetPlanCode: '0101117',
      arrears: 20000000,
      disburseNew: 8000000,
      disburseOngoing: 11000000,
      disbursePONew: 10000000,
      disbursePOOngoing: 2000000,
      bureau: 8000000,
    },
    {
      id: '9',
      budgetPlanYear: '2564',
      budgetPlanCode: '0101118',
      arrears: 22000000,
      disburseNew: 9000000,
      disburseOngoing: 12000000,
      disbursePONew: 11000000,
      disbursePOOngoing: 2000000,
      bureau: 9000000,
    },
    {
      id: '10',
      budgetPlanYear: '2564',
      budgetPlanCode: '0101119',
      arrears: 24000000,
      disburseNew: 10000000,
      disburseOngoing: 13000000,
      disbursePONew: 12000000,
      disbursePOOngoing: 2000000,
      bureau: 10000000,
    },
  ],
}
